module.exports = __webpack_public_path__ + "img/versapay_banner.94e31c9a.png";